import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { Animations, Mote, SimpleModalModule, SvgQrcodeModule } from '@motes-sdk';
import { SvgQrcodeComponent } from '@motes-sdk/components/svg-qrcode/svg-qrcode.component';
import { AutoSubOnDestroy } from '@motes-sdk/providers';
import {remove as removeDiacritics} from 'diacritics'
import { saveAs } from 'file-saver';

@AutoSubOnDestroy()
@Component({
    imports: [CommonModule, SimpleModalModule, SvgQrcodeModule],
    standalone: true,
    selector: 'qr-code-modal',
    templateUrl: './qr-code-modal.component.html',
    styleUrls: ['./qr-code-modal.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: [Animations.fadeIn(200)]
})
export class QrCodeModalComponent implements OnInit {

    @Input() activeTour: Mote = null;
    @Input() isQrCodeModalShown: boolean = false;
    @Input() qrCodeUrl: string = null;

    @Output() isQrCodeModalShownChange: EventEmitter<boolean> = new EventEmitter<boolean>();

    @ViewChild('qrcodecomponent') qrCodeComponent: SvgQrcodeComponent;

    constructor(
    ) { }

    ngOnInit(): void {
    }

    public async downloadQrCode() {
        this.setModalShown(false);

        const qrBlob = await this.qrCodeComponent.getQrCodeBlob();
        // Remove leading and trailing whitespace, convert to lowercase, convert spaces to underscores, convert diacritics and remove special characters
        const formattedFileName = removeDiacritics(this.activeTour.title.trim().toLowerCase().replace(/\s+/g, '_')).replace(/[^\w\s]/g, '')
        saveAs(qrBlob, `storyhunt_${formattedFileName || 'tour'}.png`);
    }

    public setModalShown(isShown: boolean) {
        this.isQrCodeModalShown = isShown;
        this.isQrCodeModalShownChange.emit(this.isQrCodeModalShown);
    }
}
